<ng-container>
  <div class="blog-detail">
    <div class="blog-detail-content">
      <div class="blog-heading">
        <h1>{{ post()?.title }}</h1>
      </div>
      <div class="blog-image position-relative">
        @if (buildImageSrc() | async | dotCmsCodecEncode; as imageSrc){ @if (imageSrc !== 'null') {
        <img [src]="imageSrc" alt="Image not found" />
        } @else {
        <img [src]="'/assets/img/image-not-found.jpg'" alt="Image not found" />
        } }
        <div class="blog-detail-tags">
          @for (tag of getTags(post()?.tags); track tag) {
          <span class="tag-title">
            {{ tag }}
          </span>
          }
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center">
        <div class="post-author">
          @for (blogAuthor of post()?.author; track blogAuthor) {
          <custom-dot-cms-blog-author [author]="blogAuthor" isBlog="blogAuthor" />
          }
        </div>
        <div class="text-gray-600 text-center">
          <span class="post-date"
            >@if (post()?.postingDate) {
            <i class="icon-clock"></i>
            }
            {{ post()?.postingDate | date : 'medium' }}
          </span>
        </div>
      </div>
      @if (post()?.blogContent) {
      <div class="blog-content">
        <dotcms-block-editor-renderer [blocks]="postContent()" [customRenderers]="customRenderers" />
      </div>
      }
    </div>
    <div class="box-comments">
      @if (post()?.blogComment?.length) {
      <div class="comments-heading">
        <h2>Comments</h2>
      </div>
      } @for (blogComment of post()?.blogComment; track blogComment) {
      <div class="comments-container">
        <custom-dot-cms-blog-comments [blogComment]="blogComment" />
      </div>
      }
    </div>
    @if (previousUrl$ | async; as previousUrl) {
    <button [routerLink]="[previousUrl]" class="back-button btn btn-primary">&#171; Back</button>
    }
  </div>
</ng-container>
